const updateFeature = (state, payload) => {
  state[payload.key] = payload.value
}

export default {
  updateFeature
}
